
define('modules/application/wizard/classes/perimetralProtection',[
    "app",

    // Libs
    "backbone",

    // Classes
    "./genericCollectionSection"

  ],

  function(app, Backbone, genericCollectionSection) {

    //Define a new object used to manage protections
    var protection = {

      View: Backbone.View.extend({
        tagName: "section",
        className: "protection",
        template: "application/wizard/sections/genericCollectionSection/perimetralProtection/protection",
        events: {
          "click .mainValue .ui-spinner-down": "decrementValue",
          "click .mainValue .ui-spinner-up": "incrementValue",
          "click .radio": "stateChangedEventHandler",
          "change .type": "typeChangedEventHandler"
        },
        serialize: function() {
          return {
            model: this.model,
            app: app
          };
        },
        initialize: function() {
          this.model.bind("change:value", this.valueChangedEventHandler, this);
          this.model.bind("change:number", this.numberChangedEventHandler, this);
          this.model.bind("protection:nulled", this.render, this);
          this.model.bind("protection:notNulled", this.render, this);
          this.model.bind("render:requested", this.render, this);
        },
        decrementValue: function() {
          this.model.decrementValue();
        },
        incrementValue: function() {
          this.model.incrementValue();
        },
        valueChangedEventHandler: function() {
          this.$el.find(".mainValue .spinner").html(this.model.get("value"));
        },
        typeChangedEventHandler: function(e) {
          var type = e.currentTarget.value;

          //Update the model
          this.model.setType(type);
          this.render();
        },
        numberChangedEventHandler: function() {
          this.render();
        },
        stateChangedEventHandler: function(e) {
          var protectionState = this.$el.find("input[type=\"radio\"]:checked").val();
          var volumetricProtectionLength = this.model.get("volumetricProtectionLength") ? this.model.get("volumetricProtectionLength") : 0;
          var perimetralProtectionLength = this.model.get("perimetralProtectionLength") ? this.model.get("perimetralProtectionLength") : 0;
          var radioSensorsLength = this.model.get("radioSensorsLength") ? this.model.get("radioSensorsLength") : 0;

          if (protectionState === "0") {
            if ((volumetricProtectionLength + perimetralProtectionLength + radioSensorsLength + 1) <= 9)
              this.model.set("state", protectionState);
            else {
              alert($.i18n._('IDS_W1_9128'));
              this.$el.find("input[type=\"radio\"][value=\"" + this.model.get("state") + "\"]").attr('checked', true);
              this.$el.find(".radio").remove();
              this.$el.find("input[type=\"radio\"]").removeAttr("rel");
              return;
            }
          } else
            this.model.set("state", protectionState);
        },
        afterRender: function() {
          window.customizeFormElements.call();
        }
      }),

      Model: Backbone.Model.extend({
        defaults: {
          fetchedTypes: [],
          value: 0,
          number: -1,
          maxValue: 1,
          minValue: 1,
          state: "0"
        },
        initialize: function() {
          this.unbind("change:state", this.stateChangedEventHandler);
          this.bind("change:state", this.stateChangedEventHandler, this);

          this.unbind("change:type", this.typeChangedEventHandler);
          this.bind("change:type", this.typeChangedEventHandler, this);

          this.unbind("change:value", this.valueChangedEventHandler);
          this.bind("change:value", this.valueChangedEventHandler, this);

          if (this.get("zoneEventAggregator")) {

            //Volumetric protection zone events
            this.get("zoneEventAggregator").unbind("volumetricProtection:changed", this.volumetricProtectionChangedEventHandler);
            this.get("zoneEventAggregator").bind("volumetricProtection:changed", this.volumetricProtectionChangedEventHandler, this);

            //Volumetric protection zone events
            this.get("zoneEventAggregator").unbind("perimetralProtection:changed", this.perimetralProtectionChangedEventHandler);
            this.get("zoneEventAggregator").bind("perimetralProtection:changed", this.perimetralProtectionChangedEventHandler, this);

            //Volumetric protection zone events
            this.get("zoneEventAggregator").unbind("radioSensors:changed", this.radioSensorsChangedEventHandler);
            this.get("zoneEventAggregator").bind("radioSensors:changed", this.radioSensorsChangedEventHandler, this);
          }
          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
            if (!this.get("type") && this.get("fetchedTypes").length > 0)
              this.setType(this.get("fetchedTypes")[0].packageClassId);
            else
              this.typeChangedEventHandler(true);
          }
        },
        decrementValue: function() {
          var value = this.get("value"),
            minValue = this.get("minValue");
          if ((value - 1) >= minValue) {
            this.set("value", (value - 1));
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          }
        },
        incrementValue: function() {
          var value = this.get("value"),
            maxValue = this.get("maxValue");

          if ((value + 1) <= maxValue) {
            this.set("value", (value + 1));
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          }
        },
        typeChangedEventHandler: function(mantainValue) {
          var mustMantainValue = false;
          if (mantainValue)
            mustMantainValue = mantainValue;

          var fetchedTypes, fetchedTypesLength = 0,
            i = 0;
          var that = this,
            packageClassId = that.get("type") ? that.get("type").packageClassId : that.get("type");
          if (!this.get("type") || !this.get("type").packageClassId) {

            fetchedTypes = this.get("fetchedTypes");
            fetchedTypesLength = fetchedTypes.length;
            for (i = 0; i < fetchedTypesLength; i++) {
              if (fetchedTypes[i].packageClassId === this.get("type")) {
                this.set("type", fetchedTypes[i]);
                break;
              }
            }
          }

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageClassId, function(data) {
            data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
            var products = _.filter(data.products, function(product) {
              return (product.mnemonic === 1);
            });
            var secondaryProducts = _.filter(data.products, function(product) {
              return (product.mnemonic !== 1);
            });
            products = products[0];

            if (that.attributes.type instanceof Object)
              _.extend(that.attributes.type, products);
            else {
              that.attributes.type = products;
              BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(packageClassId, function(packageData) {
                _.extend(that.attributes.type, packageData);
              });
            }
            that.attributes.type.secondaryProducts = secondaryProducts;
          });

          this.setMValues();
          if (!mustMantainValue)
            this.set("value", this.get("minValue"));

          if (this.get("type") && this.get("type").packageClassId === "4501")
            this.set("value", 1);

          if (this.get("collectionEventAggregator"))
          {
            this.get("collectionEventAggregator").trigger("sort:requested");
          }

          this.trigger("render:requested");
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },
        stateChangedEventHandler: function() {
          if (this.get("state") !== 0)
            this.trigger("protection:nulled");
          else
            this.trigger("protection:notNulled");
          this.get("collectionEventAggregator").trigger("sort:requested");
          this.trigger("render:requested");
        },
        volumetricProtectionChangedEventHandler: function(radioSensors) {
          this.set("volumetricProtectionLength", radioSensors);
        },
        perimetralProtectionChangedEventHandler: function(radioSensors) {
          this.set("perimetralProtectionLength", radioSensors);
        },
        radioSensorsChangedEventHandler: function(radioSensors) {
          this.set("radioSensorsLength", radioSensors);
        },
        valueChangedEventHandler: function() {
          this.trigger("render:requested");
        },
        renderRequestedEventHandler: function() {
          var collection = this.get("collection"),
            collectionLength = collection ? collection.models.length : 0;

          for (var i = 0; i < collectionLength; i++) {
            collection.models[i].trigger("render:requested");
          }
        },
        setType: function(typePackageClassId) {
          var filteredTypes = [];
          var originalTypes = this.get("fetchedTypes"),
            originalTypesLength = originalTypes.length;
          var i = 0;

          //Cloning interface's array
          for (i = 0; i < originalTypesLength; i++) {
            filteredTypes.push(_.extend(originalTypes[i]));
          }

          //retrieve the correct interfacePackageClassId
          filteredTypes = _.filter(filteredTypes, function(currentType) {
            return (currentType.packageClassId === typePackageClassId);
          });

          //Setting interface attribute
          if (filteredTypes.length > 0)
            this.set("type", filteredTypes[0]);
          else
            this.set("type", {
              packageClassId: typePackageClassId
            });
        },
        setMValues: function() {
          if (this.get("type")) {
            var packageClassId = this.get("type").packageClassId;
            var maxValue = this.get("type").specialVars.maxValue,
              minValue = this.get("type").specialVars.minValue;

            if ((maxValue !== -1) && (minValue !== -1)) {
              this.set("maxValue", maxValue);
              this.set("minValue", minValue);
              this.set("value", minValue);
            }
          }
        }
      })

    };

    var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {
      View: genericCollectionSection.genericCollectionItem.View.extend({
        tagName: "li",
        className: "perimetralProtection",
        template: "application/wizard/sections/genericCollectionSection/perimetralProtection",
        events: _.extend({
          "change .interface"              : "interfaceChangedEventHandler",
          "keyup input[name='description']": "descriptionChangedEventHandler"
        }, genericCollectionSection.genericCollectionItem.View.prototype.events),

        initialize: function() {
          genericCollectionSection.genericCollectionItem.View.prototype.initialize.apply(this);
          this.model.bind("render:requested", this.render, this);
          this.model.bind("change:number", this.render, this);
        },

        interfaceChangedEventHandler: function(e) {
          var interfacePackageClassId = e.target.value;
          this.model.setInterface(e.target.value);
          this.render();
        },
        descriptionChangedEventHandler: function(e) {
          this.model.set("description", e.currentTarget.value);
        },
        typeChangedEventHandler: function() {
          //
        },
        beforeRender: function() {
          genericCollectionSection.genericCollectionItem.View.prototype.beforeRender.apply(this);
          var i = 0,
            protections = this.model.get("protections"),
            protectionsLength = protections.length;

          for (i = 0; i < protectionsLength; i++) {
            this.insertView(".protectionsSection", new protection.View({
              model: protections[i]
            }));
          }
        }
      }),

      Model: genericCollectionSection.genericCollectionItem.Model.extend({
        defaults: {
          selected: false,
          numberOfProtections: 0,
          protections: [],
          startNumber: 1
        },

        initialize: function() {
          var collectionItemModel = genericCollectionItem.Model;
          var collectionModel = Backbone.Collection.extend({
            model: collectionItemModel
          });
          var collection;
          var oldCollection, i = 0;

          genericCollectionSection.genericCollectionItem.Model.prototype.initialize.apply(this);

          this.bind("change:_interface", this.interfaceChangedEventHandler, this);
          this.bind("change:fetchedTypes", this.updateFetchedTypes, this);

          if (!this.get("_interface") && this.get("fetchedInterfaces").length > 0)
            this.setInterface(this.get("fetchedInterfaces")[0].packageClassId);
          else
            this.interfaceChangedEventHandler(true);

          //Reinstancing protections
          var protections = this.get("protections");

          if ((protections) && (protections.length > 0)) {
            for (i = 0; i < protections.length; i++)
              if (protections[i].attributes)
                protections[i] = new protection.Model(_.extend({
                  collectionEventAggregator: this.get("collectionEventAggregator"),
                  zoneEventAggregator: this.get("zoneEventAggregator"),
                  fetchedTypes: this.retrieveFilteredTypes()
                }, protections[i].toJSON()));
              else
                protections[i] = new protection.Model(_.extend({
                  collectionEventAggregator: this.get("collectionEventAggregator"),
                  zoneEventAggregator: this.get("zoneEventAggregator"),
                  fetchedTypes: this.retrieveFilteredTypes()
                }, protections[i]));

            this.set("protections", protections);
          }

          this.bind("change:numberOfProtections", this.numberOfProtectionsChangedEventHandler, this);
        },

        updateFetchedTypes: function() {
          var protections = this.get("protections");
          if (protections)
            for (i = 0; i < protections.length; i++) {
              protections[i].set("fetchedTypes", this.retrieveFilteredTypes());
              protections[i].set("type", this.get("fetchedTypes")[0]);
            }

        },

        selectedStatusChangedEventHandler: function() {
          if (this.get("selected"))
            this.get("collectionEventAggregator").trigger("selectedItem:changed", this);
          this.trigger("render:requested");
        },

        retrieveFilteredTypes: function() {
          var interfacePackageCompatibilities = this.get("_interface").packageClassId,
            filteredTypes = [],
            compatibleTypes = this.get("_interface").specialVars;

          if (typeof compatibleTypes !== "object")
            compatibleTypes = JSON.parse(compatibleTypes).protectionCompatibilities;
          else
            compatibleTypes = compatibleTypes.protectionCompatibilities;

          filteredTypes = _.filter(this.get("fetchedTypes"), function(type) {
            return (_.indexOf(compatibleTypes, type.specialVars.protectionType) !== -1);
          });
          return filteredTypes;
        },

        retrieveNumberOfProtections: function() {
          if (this.get("_interface").specialVars)
            if (typeof this.get("_interface").specialVars !== "object")
              this.get("_interface").specialVars = JSON.parse(this.get("_interface").specialVars);


          return this.get("_interface").specialVars.numberOfProtections;
        },

        setInterface: function(interfacePackageClassId) {
          var filteredInterfaces = [];
          var originalInterfaces = this.get("fetchedInterfaces"),
            originalInterfacesLength = originalInterfaces.length;
          var i = 0;

          //Cloning interface's array
          for (i = 0; i < originalInterfacesLength; i++) {
            filteredInterfaces.push(_.extend(originalInterfaces[i]));
          }

          //retrieve the correct interface
          filteredInterfaces = _.filter(filteredInterfaces, function(currentInterface) {
            return (currentInterface.packageClassId === interfacePackageClassId);
          });

          //Setting interface attribute
          if (filteredInterfaces.length > 0)
            this.set("_interface", filteredInterfaces[0]);
          this.get("collectionEventAggregator").trigger("render:requested");
        },

        setNumberOfProtections: function(numberOfProtections) {
          this.set("numberOfProtections", numberOfProtections);
        },

        interfaceChangedEventHandler: function(startHandler) {
          var _interface = this.get("_interface"),
            that = this;

          //Merging with wizard package attributes
          var packageClassAttributes = _.filter(that.get("fetchedInterfaces"), function(pack) {
            return pack.packageClassId === _interface.packageClassId;
          });

          if (packageClassAttributes.length === 1)
            packageClassAttributes = packageClassAttributes[0];

          _.extend(this.attributes, packageClassAttributes);

          //Merging with item's attributes
          if ((_interface) && (_interface.packageClassId)) {
            BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(_interface.packageClassId, function(packagesData) {
              _interface = packagesData;

              if (_interface.specialVars)
                _interface.specialVars = JSON.parse(_interface.specialVars);

              BticinoS4B.Instances.Models.ApplicationModel.getProducts(_interface.packageClassId, function(productData) {
                productData.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(productData.products);
                var products = _.filter(productData.products, function(product) {
                  return (product.mnemonic === 1);
                });
                var secondaryProducts = _.filter(productData.products, function(product) {
                  return (product.mnemonic !== 1);
                });
                products = products[0];
                _interface = _.extend(_interface, products);
                _interface.secondaryProducts = secondaryProducts;
                that.set("_interface", _interface);
              });

            });
          } else {
            this.resetValues();
          }

          this.setNumberOfProtections(this.retrieveNumberOfProtections());
          this.createProtectionCollection(startHandler);
          this.get("collectionEventAggregator").trigger("render:requested");
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },

        createProtectionCollection: function(force) {
          var protections = [],
            oldProtections = this.get("protections"),
            numberOfProtections, types, i = 0;
          var protectionModelToAdd;
          var startNumber = this.get("startNumber");

          if ((!oldProtections) || (oldProtections.length === 0) || (force)) {
            types = this.retrieveFilteredTypes();
            numberOfProtections = this.get("numberOfProtections");
          }

          if (oldProtections.length === 0) {
            for (i = 0; i < numberOfProtections; i++) {
              if (i === 0)
                protectionModelToAdd = new protection.Model({
                  fetchedTypes: types,
                  number: (startNumber + i),
                  nullable: false,
                  collectionEventAggregator: this.get("collectionEventAggregator"),
                  zoneEventAggregator: this.get("zoneEventAggregator")
                });
              else
                protectionModelToAdd = new protection.Model({
                  fetchedTypes: types,
                  number: (startNumber + i),
                  nullable: true,
                  state: "0",
                  collectionEventAggregator: this.get("collectionEventAggregator"),
                  zoneEventAggregator: this.get("zoneEventAggregator")
                });

              protections.push(protectionModelToAdd);
            }
          } else {
            for (i = 0; i < numberOfProtections; i++) {
              if (oldProtections[i].toJSON)
                protectionModelToAdd = new protection.Model(_.extend(oldProtections[i].toJSON(), {
                  fetchedTypes: types,
                  collectionEventAggregator: this.get("collectionEventAggregator"),
                  zoneEventAggregator: this.get("zoneEventAggregator"),
                  nullable: (i !== 0)
                }));
              else
                protectionModelToAdd = new protection.Model(_.extend(oldProtections[i], {
                  fetchedTypes: types,
                  collectionEventAggregator: this.get("collectionEventAggregator"),
                  zoneEventAggregator: this.get("zoneEventAggregator"),
                  nullable: (i !== 0)
                }));
              protections.push(protectionModelToAdd);
            }
          }

          this.set("protections", protections);
          if (this.get("collectionEventAggregator"))
          {
            this.get("collectionEventAggregator").trigger("sort:requested");
          }
        },

        numberOfProtectionsChangedEventHandler: function() {
          this.createProtectionCollection();
        },

        resetValues: function() {
          this.set("catalogId", undefined);
          this.set("description", undefined);
          this.set("image", undefined);
          this.set("links", undefined);
          this.set("mnemonic", undefined);
          this.set("optionalPackages", undefined);
          this.set("packageActuator", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
          this.set("packageInDepth", undefined);
          this.set("packageLoad", undefined);
          this.set("price", undefined);
          this.set("productCode", undefined);
          this.set("productDescription", undefined);
          this.set("productInDepth", undefined);
          this.set("productLabel", undefined);
          this.set("specialVars", undefined);
          this.set("wizardChoiceDescription", undefined);
          this.set("wizardChoiceLabel", undefined);
          this.set("packageClassDescription", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
        },

        getLastNumber: function() {
          var protectionCollection = this.get("protections"),
            protectionCollectionLength = protectionCollection.length;

          if (protectionCollectionLength === 1) {
            return protectionCollection[0].get("number");
          } else {
            if (protectionCollection[1].get("number") === "_")
              return protectionCollection[0].get("number");
            else
              return protectionCollection[1].get("number");
          }
        },

        deliverCurrent: function() {
          var currentConsumption = 0,
            i = 0;
          var _interface = this.get("_interface");
          var protections = this.get("protections");
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

          if ((_interface) && (_interface.specialVars)) {
            currentConsumption = _interface.specialVars.currentConsumption;
            if (currentConsumption < 0)
              consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
            else
              consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
          }

          currentConsumption = 0;

          if (protections)
            for (i = 0; i < protections.length; i++) {
              if (protections[i].get("type") && protections[i].get("type").specialVars) {
                currentConsumption = protections[i].get("type").specialVars.currentConsumption * protections[i].get("value");
                if (currentConsumption < 0)
                  consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
                else
                  consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
              }
            }
        }
      })
    });

    var perimetralProtection = _.extend({}, genericCollectionSection, {

      Views: {
        titleBar: genericCollectionSection.Views.titleBar.extend(),
        content: genericCollectionSection.Views.content.extend({
          template: "application/wizard/sections/genericCollectionSection/collectionWithInfo",
          events: _.extend(_.extend({}, genericCollectionSection.Views.content.prototype.events), {
            "click .toggleInfoButton": "toggleInfos"
          }),
          toggleInfos: function(e) {
            return genericCollectionSection.Views.content.prototype.toggleInfos(e, this);
          },
          renderRequestedEventHandler: function() {
            this.render();
          },

          addItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.addItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              this.insertView(".elements", viewToAdd);
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          beforeRender: function() {
            var collection = this.model.get("collection"),
              collectionLength = collection.models.length;
            var collectionItemView = genericCollectionItem.View;
            var i = 0;

            for (i = 0; i < collectionLength; i++)
              this.insertView(".elements", new collectionItemView({
                model: collection.models[i]
              }));
          },

          afterRender: function() {
            if (this.model.get("collection").length === 0)
              this.$el.append("<h4 class='alert'>" + $.i18n._("IDS_WAI1001_9018") + "</h4>");
            window.customizeFormElements.call();
          }
        })
      },

      Model: genericCollectionSection.Model.extend({
        defaults: _.extend({
          name: "IDS_WAI8_9",
          collectionEventAggregator: _.extend({}, Backbone.Events),
          infoQuote: "IDS_WGENTT_000023"
        }, genericCollectionSection.Model.prototype.defaults),

        initialize: function() {
          genericCollectionSection.Model.prototype.initialize.apply(this);
          var collection;
          var collectionItemModel = genericCollectionItem.Model;
          var collectionModel = Backbone.Collection.extend({
            model: collectionItemModel
          });
          var oldCollection;
          var originalCollection, collectionEventAggregator;

          var originalProtection, clonedProtection, protections = [];
          var i = 0,
            j = 0;


          //Volumetric protection zone events
          this.get("zoneEventAggregator").unbind("volumetricProtection:changed", this.volumetricProtectionChangedEventHandler);
          this.get("zoneEventAggregator").bind("volumetricProtection:changed", this.volumetricProtectionChangedEventHandler, this);

          //Radio sensors zone events
          this.get("zoneEventAggregator").unbind("radioSensors:changed", this.radioSensorsChangedEventHandler);
          this.get("zoneEventAggregator").bind("radioSensors:changed", this.radioSensorsChangedEventHandler, this);

          //Lengths communication events
          this.get("zoneEventAggregator").unbind("communicate:lengths", this.lengthsCommunicationRequested);
          this.get("zoneEventAggregator").bind("communicate:lengths", this.lengthsCommunicationRequested, this);

          this.get("collectionEventAggregator").bind("selectedItem:changed", this.selectedItemChangedEventHandler, this);

          this.get("collectionEventAggregator").unbind("sort:requested", this.sortItems);
          this.get("collectionEventAggregator").bind("sort:requested", this.sortItems, this);

          window.BticinoS4B.eventAggregator.unbind("perimetralProtection:addedFromKit", this.productAddedFromKitEventHandler);
          window.BticinoS4B.eventAggregator.bind("perimetralProtection:addedFromKit", this.productAddedFromKitEventHandler, this);

          window.BticinoS4B.eventAggregator.bind("zonesWithoutOneFreePProtection:check", this.addAvailability, this);

          window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen', this.accessoryLineChosenEventHandler);
          window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen', this.accessoryLineChosenEventHandler, this);

          //Tolto per non far scattare doppio il trigger
          // window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.deliverCurrent);
          // window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);

          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") && BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") !== 0)
            this.fetchPackages();
          else
            window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.fetchPackages, this);

          if (!this.get("collection") || this.get("collection").length===0)
            this.set("collection", new collectionModel());
          else {
            //Creating new event aggregator
            collectionEventAggregator = _.extend({}, Backbone.Events);

            if (this.get("collection")) {
              oldCollection = this.get("collection");

              if (oldCollection.models)
                oldCollection = oldCollection.models;
            }

            this.set("collection", new collectionModel());
            collection = this.get("collection");
            // this.get("collectionEventAggregator").set("collection",collection);

            if (oldCollection) {
              for (i = 0; i < oldCollection.length; i++) {
                if (!oldCollection[i].attributes) {
                  if (oldCollection[i]._interface.isMCUContact)
                    this.addMainControlUnitContactItem(_.extend(oldCollection[i], {
                      collectionEventAggregator: this.get("collectionEventAggregator")
                    }));
                  else
                    this.addItem(_.extend(oldCollection[i], {
                      collectionEventAggregator: this.get("collectionEventAggregator")
                    }));
                } else
                  collection.add(new collectionItemModel(_.extend(oldCollection[i].toJSON(), {
                    collectionEventAggregator: this.get("collectionEventAggregator")
                  })));
              }
            }
          }

          if ((!this.get("volumetricProtectionLength")) || (!this.get("radioSensorsLength"))) {
            this.get("zoneEventAggregator").trigger("communicate:lengths");
          }

          this.sortItems();
        },

        addAvailability: function() {
          var zonesWithoutOneFreePProtection = BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") : [];
          if (!this.isPossibleToAddAMcuContact())
            zonesWithoutOneFreePProtection.push(this.get("zoneNumber"));

          BticinoS4B.Instances.Models.ApplicationModel.set("zonesWithoutOneFreePProtection", zonesWithoutOneFreePProtection);
        },

        zoneNumberChangedEventHandler: function(newZoneNumber) {
          var collection = this.get("collection");

          for (var i = collection.models.length - 1; i >= 0; i--)
            if (collection.models[i].get("partOfMainControlUnit"))
              collection.models[i].get("mainControlUnitEventAggregator").trigger("zoneNumber:changed", newZoneNumber);
        },

        accessoryLineChosenEventHandler: function() {
          var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
          var callback = function(scope) {
            if (!scope.get("type") && scope.get("fetchedTypes").length > 0)
              scope.set("type", scope.get("fetchedTypes")[0].packageClassId);
            else
              if(typeof scope.typeChangedEventHandler == 'function')
                scope.typeChangedEventHandler();

            scope.updateProtections();
          };

          if (accessoryLineId !== 0)
            this.fetchPackages(callback);
        },

        fetchPackages: function(callback) {
          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
            var that = this;
            var firstFinished = false,
              secondFinished = false;

            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(409, function(data) {
              for (var i = 0; i < data.packages.length; i++) {
                data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);
              }
              that.set("fetchedInterfaces", data.packages);
              firstFinished = true;

              if (callback && firstFinished && secondFinished)
                callback(that);
            });

            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(410, function(data) {
              for (var i = data.packages.length - 1; i >= 0; i--) {
                data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);
              }
              that.set("fetchedTypes", data.packages);

              secondFinished = true;

              if (callback && firstFinished && secondFinished)
                callback(that);
            });
          }
        },

        isDuplicable: function() {
          var isDuplicable = true,
            collection = this.get("collection");

          for (var i = collection.models.length - 1; i >= 0; i--) {
            isDuplicable = collection.models[i].get("connectedTo") ? false : true;
          }

          return isDuplicable;
        },

        isRemovable: function() {
          var isRemovable = true,
            collection = this.get("collection");

          for (var i = collection.models.length - 1; i >= 0; i--) {
            isRemovable = collection.models[i].get("connectedTo") ? false : true;
          }

          return isRemovable;
        },

        getNewNumber: function() {
          return (this.getNumberOfProtections() + this.get("volumetricProtectionLength") + 1);
        },

        productAddedFromKitEventHandler: function(addedPerimetralProtection) {
          this.addItem({
            packageClassId: addedPerimetralProtection.perimetralProtection,
            partOfKit: true
          });
        },

        lengthsCommunicationRequested: function() {
          if (this.get("collection"))
            this.get("zoneEventAggregator").trigger("perimetralProtection:changed", this.get("collection").models.length);
          else
            this.get("zoneEventAggregator").trigger("perimetralProtection:changed", 0);
        },

        volumetricProtectionChangedEventHandler: function(volumetricProtections) {
          this.set("volumetricProtectionLength", volumetricProtections);
          this.sortItems();
        },

        radioSensorsChangedEventHandler: function(radioSensors) {
          this.set("radioSensorsLength", radioSensors);
          this.sortItems();
        },

        renderRequestedEventHandler: function() {
          var collection = this.get("collection"),
            collectionLength = collection ? collection.models.length : 0;

          for (var i = 0; i < collectionLength; i++) {
            collection.models[i].trigger("render:requested");
          }
        },

        getNumberOfProtections: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var i = 0,
            j = 0;
          var protections,
            protection,
            numberOfProtections = 0;

          for (i = 0; i < collectionLength; i++) {
            protections = collection.models[i].get("protections");
            for (j = 0; j < protections.length; j++) {
              protection = protections[j];
              if ((!protection.get("nullable")) || (protection.get("state") === "0")) {
                numberOfProtections++;
              }
            }
          }

          return numberOfProtections;
        },

        selectedItemChangedEventHandler: function(choosenElement) {
          var collection = this.get("collection");
          for (var i = 0; i < collection.models.length; i++) {
            if (collection.models[i] !== choosenElement)
              collection.models[i].set("selected", false);
          }
        },

        isPossibleToAddAMcuContact: function() {
          //Retrieving collections length
          var volumetricProtectionLength = this.get("volumetricProtectionLength") ? this.get("volumetricProtectionLength") : 0;
          var radioSensorsLength = this.get("radioSensorsLength") ? this.get("radioSensorsLength") : 0;

          return (this.getNumberOfProtections() + volumetricProtectionLength + radioSensorsLength + 1) <= this.get("maxItem");
        },

        isPossibleToAdd: function() {
          //Retrieving collections length
          var volumetricProtectionLength = this.get("volumetricProtectionLength") ? this.get("volumetricProtectionLength") : 0;
          var radioSensorsLength = this.get("radioSensorsLength") ? this.get("radioSensorsLength") : 0;

          return (this.getNumberOfProtections() + volumetricProtectionLength + radioSensorsLength + 2) <= this.get("maxItem");
        },

        addMainControlUnitContactItem: function(item) {
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(item._interface.packageClassId, function(data) {
            item = data;
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(item.packageClassId, function(productData) {
              item = _.extend(item, productData);
            });
          });
          this.addMainControlUnitContact(item);
        },

        addMainControlUnitContact: function(contactToConnect) {
          var modelToAdd;

          //Retrieving collection's item constructor (for semplicity and clarity)
          var collectionItemModel = genericCollectionItem.Model;

          //Retrieving collection (for semplicity and clarity)
          var collection = this.get("collection"),
            collectionLength = collection.models.length;

          if (this.isPossibleToAddAMcuContact()) {

            modelToAdd = new collectionItemModel({
              _interface: contactToConnect,
              fetchedInterfaces: [contactToConnect],
              collectionEventAggregator: this.get("collectionEventAggregator"),
              fetchedTypes: this.get("fetchedTypes"),
              cannotBeRemoved: true,
              partOfMainControlUnit: true
            });

            //Adding model to the collection
            collection.add(modelToAdd);

            //Sort collection's items
            this.sortItems();

            this.trigger("updateViews", this.get("collection").length);

            //Update current perimetral protection length value
            this.get("zoneEventAggregator").trigger("perimetralProtection:changed", this.getNumberOfProtections());

            //Trigger event for zone validation
            this.trigger("item:added");

            //window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            this.trigger("render:requested");

            return modelToAdd;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        removeMainControlUnitContact: function(contactToDisconnect) {
          var collection = this.get("collection"),
            contactsToRemove = _.filter(collection.models, function(iterableItem) {
              return iterableItem.get("packageClassId") === contactToDisconnect.packageClassId;
            });

          for (var i = 0, length = contactsToRemove.length; i < length; i++) {
            this.removeItem(contactsToRemove[i], true, true);
          }
          //Per quando si cambiano i contatti dalla centrale
          this.get("collectionEventAggregator").unbind("duplication:requested", this.duplicationRequestedEventHandler);
          this.get("collectionEventAggregator").bind("duplication:requested", this.duplicationRequestedEventHandler, this);
          this.get("collectionEventAggregator").unbind("delete:requested", this.deleteRequestedEventHandler);
          this.get("collectionEventAggregator").bind("delete:requested", this.deleteRequestedEventHandler, this);

          this.trigger("render:requested");
        },

        removeMainControlUnitContacts: function() {
          var collection = this.get("collection"),
            contactsToRemove = _.filter(collection.models, function(iterableItem) {
              return iterableItem.get("partOfMainControlUnit") === true;
            });

          if (contactsToRemove.length>0)
          {
            for (var i = 0, length = contactsToRemove.length; i < length; i++)
            {
              this.removeItem(contactsToRemove[i], true, true, true);
            }
          }
          //Per quando si cambiano i contatti dalla centrale
          this.get("collectionEventAggregator").unbind("duplication:requested", this.duplicationRequestedEventHandler);
          this.get("collectionEventAggregator").bind("duplication:requested", this.duplicationRequestedEventHandler, this);
          this.get("collectionEventAggregator").unbind("delete:requested", this.deleteRequestedEventHandler);
          this.get("collectionEventAggregator").bind("delete:requested", this.deleteRequestedEventHandler, this);

          this.trigger("render:requested");
        },

        updateProtections: function() {
          var collection = this.get("collection"),
            fetchedTypes = this.get("fetchedTypes"),
            interfacesToPass = _.filter(this.get("fetchedInterfaces"), function(iterableInterface) {
              return !iterableInterface.specialVars.mainControlUnitContact;
            });


          for (var i = collection.length - 1; i >= 0; i--) {
            collection.models[i].set("fetchedTypes", fetchedTypes);
            //collection.models[i].set("fetchedInterfaces", interfacesToPass);
            collection.models[i].trigger("render:requested");
          }
        },

        addItem: function(itemModel) {
          var modelToAdd;

          //Retrieving collection's item constructor (for semplicity and clarity)
          var collectionItemModel = genericCollectionItem.Model;

          //Retrieving collection (for semplicity and clarity)
          var collection = this.get("collection"),
            collectionLength = collection.models.length,
            interfacesToPass = _.filter(this.get("fetchedInterfaces"), function(iterableInterface) {
              return !iterableInterface.specialVars.mainControlUnitContact;
            });
            this.get("collectionEventAggregator").unbind("duplication:requested", this.duplicationRequestedEventHandler);
            this.get("collectionEventAggregator").bind("duplication:requested", this.duplicationRequestedEventHandler, this);
            this.get("collectionEventAggregator").unbind("delete:requested", this.deleteRequestedEventHandler);
            this.get("collectionEventAggregator").bind("delete:requested", this.deleteRequestedEventHandler, this);

          if (this.isPossibleToAdd()) {

            if (itemModel) {
              if (itemModel.partOfKit)
                modelToAdd = new collectionItemModel(_.extend(itemModel, {
                  fetchedInterfaces: interfacesToPass,
                  fetchedTypes: this.get("fetchedTypes"),
                  number: this.getNewNumber(),
                  collectionEventAggregator: this.get("collectionEventAggregator"),
                  zoneEventAggregator: this.get("zoneEventAggregator")
                }));
              else
                modelToAdd = new collectionItemModel(_.extend(itemModel, {
                  fetchedInterfaces: interfacesToPass,
                  fetchedTypes: this.get("fetchedTypes")
                }));
            } else
              modelToAdd = new collectionItemModel({
                fetchedInterfaces: interfacesToPass,
                fetchedTypes: this.get("fetchedTypes"),
                number: this.getNewNumber(),
                collectionEventAggregator: this.get("collectionEventAggregator"),
                zoneEventAggregator: this.get("zoneEventAggregator")
              });

            //Adding model to the collection
            collection.add(modelToAdd);
            // this.get("collectionEventAggregator").set("collection",collection);

            //Setting selected properties
            modelToAdd.set("selected", true);

            //Sort collection's items
            this.sortItems();

            this.trigger("updateViews", this.get("collection").length);

            //Update current perimetral protection length value
            this.get("zoneEventAggregator").trigger("perimetralProtection:changed", this.getNumberOfProtections());

            //Trigger event for zone validation
            this.trigger("item:added");

            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

            return modelToAdd;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        duplicateItem: function(modelToDuplicate) {

          //Variables definition
          var modelToAdd;

          //Retrieving collection's item constructor (for semplicity and clarity)
          var collectionItemModel = genericCollectionItem.Model;

          //Retrieving collection (for semplicity and clarity)
          var collection        = this.get("collection"),
              collectionLength  = collection.models.length;
          this.get("collectionEventAggregator").unbind("duplication:requested", this.duplicationRequestedEventHandler);
          this.get("collectionEventAggregator").bind("duplication:requested", this.duplicationRequestedEventHandler, this);
          this.get("collectionEventAggregator").unbind("delete:requested", this.deleteRequestedEventHandler);
          this.get("collectionEventAggregator").bind("delete:requested", this.deleteRequestedEventHandler, this);

          //Retrieving collections length
          var volumetricProtectionLength  = this.get("volumetricProtectionLength") ? this.get("volumetricProtectionLength") : 0;
          var radioSensorsLength          = this.get("radioSensorsLength") ? this.get("radioSensorsLength") : 0;

          if ((this.getNumberOfProtections() + volumetricProtectionLength + radioSensorsLength + 2) <= this.get("maxItem")) {
            if (modelToDuplicate) {

              //Instancing new model
              modelToAdd              = $.extend(true, {}, modelToDuplicate.attributes);
              modelToAdd.protections  = [];
              modelToAdd              = new collectionItemModel(modelToAdd);

              var protections = [];
              for (var i = 0; i < modelToDuplicate.get("protections").length; i++) {
                protections.push(new protection.Model(_.extend({
                  fetchedTypes: this.get("fetchedTypes")
                }, modelToDuplicate.get("protections")[i].toJSON())));
              }
              modelToAdd.set("protections", protections);

              if (modelToAdd) {

                //Adding model to the current collection
                collection.add(modelToAdd);

                //Sort collection's items
                this.sortItems();

                this.trigger("updateViews", this.get("collection").length);

                //Trigger event to advice the perimetral protection change
                this.get("zoneEventAggregator").trigger("perimetralProtection:changed", this.getNumberOfProtections());

                //Trigger event for zone validation
                this.trigger("item:added", modelToAdd);
                this.trigger("render:requested");

                window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

                return modelToAdd;
              } else
                return false;
            } else
              return false;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        sortItems: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length,
            startNumber = this.get("volumetricProtectionLength") ? this.get("volumetricProtectionLength") + 1 : 1;
          var i = 0,
            j = 0;
          var protections,
            protection,
            numberOfProtections = 0;

          for (i = 0; i < collectionLength; i++) {
            protections = collection.models[i].get("protections");
            for (j = 0; j < protections.length; j++) {
              protection = protections[j];

              if ((!protection.get("nullable")) || (protection.get("state") === "0")) {
                protection.set("number", (startNumber + i + j));
                numberOfProtections++;
              }
            }

            startNumber += (numberOfProtections - 1);

            if ((protection) && (i === (collectionLength - 1)))
              protection.set("selected", true);

            numberOfProtections = 0;
          }
          this.get("zoneEventAggregator").trigger("perimetralProtection:changed", this.getNumberOfProtections());
        },

        removeItem: function(modelToRemove, silent, force) {
          var collection = this.get("collection");
          if (modelToRemove && (!modelToRemove.get('cannotBeRemoved')||force))
          {
            if (this.deleteItem(modelToRemove, silent))
            {
              this.get("zoneEventAggregator").trigger("perimetralProtection:changed", this.getNumberOfProtections());
              this.sortItems();

              if (collection.models.length > 0)
              {
                collection.models[collection.models.length - 1].set("selected", true);
              }

              this.trigger("updateViews", this.get("collection").length);
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

              this.sortItems();
              //Trigger event for zone validation
              this.trigger("item:removed",modelToRemove);
              return modelToRemove;
            } else
              return false;
          } else
            return false;
        },

        deliverCurrent: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var i = 0;

          for (i = 0; i < collectionLength; i++)
            collection.models[i].deliverCurrent();
        }
      }),
      genericCollectionItem: genericCollectionItem
    });

    // Required, return the module for AMD compliance
    return perimetralProtection;

  });